
import ReservierungLogic from '@/logic/bestellung/reservierung_logic'
import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export default class Reservierung extends Vue {
    logic: ReservierungLogic = null

    mounted() {
        this.logic = new ReservierungLogic()
        this.logic.init(this.$route.params.reservierungId)
    }
}
